module.exports = __webpack_public_path__ + "img/garden_club_paraguayo.e07d70ff.png";